import React, { useState } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import { Card, Tabs } from 'antd'
import {
  fetchAppVersionByType,
  updateAppVersion
} from '../../modules/appVersion'
import ForceUpdateForm from './ForceUpdateForm'

const TabPane = Tabs.TabPane

const APP_TYPES = [
  { key: 'user', label: 'User App' },
  { key: 'hero', label: 'Hero App' },
  { key: 'loma', label: 'LOMA App' }
]

const ForceUpdate = () => {
  const dispatch = useDispatch()
  const [activeTab, setActiveTab] = useState('user')

  const { appVersionObj, isLoading } = useSelector(
    (state) => ({
      appVersionObj: state.appVersion.appVersionObj,
      isLoading: state.appVersion.isLoading
    }),
    shallowEqual
  )

  useDeepEffect(() => {
    dispatch(fetchAppVersionByType(activeTab))
  }, [activeTab])

  const onSave = async (values) => {
    const data = {
      ...values,
      appType: activeTab
    }
    if (appVersionObj && appVersionObj.id) {
      data.id = appVersionObj.id
    }
    await dispatch(updateAppVersion(data))
    await dispatch(fetchAppVersionByType(activeTab))
  }

  return (
    <Card title="Force Update">
      <Tabs activeKey={activeTab} onChange={(key) => setActiveTab(key)}>
        {APP_TYPES.map((app) => (
          <TabPane tab={app.label} key={app.key}>
            <ForceUpdateForm
              key={activeTab}
              formData={appVersionObj}
              isLoading={isLoading}
              onSave={onSave}
              showWindows={app.key === 'loma'}
            />
          </TabPane>
        ))}
      </Tabs>
    </Card>
  )
}

export default ForceUpdate
